import type { ArticleData } from "@qendo/resources";
import { useState } from "react";
import { StyleSheet, View } from "react-native";
import { FilteredList } from "~/components/layout/FilteredList";
import { Page } from "~/components/layout/Page";
import { Article } from "~/components/layout/resources/Article";
import { SectionHeader } from "~/components/layout/SectionHeader";
import { Only } from "~/components/permission/Only";
import { Space } from "~/constants/sizing";
import { useResources } from "~/providers/ResourcesProvider";
import { searchMatches } from "~/util/string";

export default function BlogIndex() {
    const { blogs, refreshBlog } = useResources();
    const [refreshing, setRefreshing] = useState(false);

    const refresh = async () => {
        if (refreshing) {
            return;
        }

        setRefreshing(true);
        await refreshBlog().finally(() => setRefreshing(false));
    };

    return (
        <Page spacer scrollable={false}>
            <SectionHeader title="QENDO Blog" icon="books">
                Expert advice, personal stories, and resources to help you navigate life with endometriosis.
            </SectionHeader>
            <Only
                when={blogs.length}
                show={() => (
                    <FilteredList<ArticleData>
                        data={blogs}
                        searchWith={(item, search) => searchMatches(search, item.search)}
                        keyExtractor={(item) => item.key}
                        searchPlaceholder="Search articles"
                        refreshWith={refresh}
                        isRefreshing={refreshing}
                        ItemSeparatorComponent={() => <View style={styles.separator} />}
                        renderItem={({ item }) => <Article article={item} />}
                    />
                )}
            />
        </Page>
    );
}

const styles = StyleSheet.create({
    separator: {
        height: Space.md,
    },
});
